import React from "react";
import { CALENDAR_ACCENT } from "./CalendarConstants";

const VIEWS = [
  { key: "month", label: "Monat" },
  { key: "week", label: "Woche" },
  { key: "day", label: "Tag" },
];

const ViewSelector = ({ selected, onChanged }) => {
  return (
    <div style={{
      display: "inline-flex",
      borderRadius: 8,
      border: "1px solid #ccc",
      overflow: "hidden",
    }}>
      {VIEWS.map(({ key, label }) => {
        const isActive = selected === key;
        return (
          <button
            key={key}
            onClick={() => onChanged(key)}
            style={{
              padding: "5px 16px",
              fontSize: 13,
              fontWeight: 500,
              border: "none",
              cursor: "pointer",
              backgroundColor: isActive ? CALENDAR_ACCENT : "transparent",
              color: isActive ? "#fff" : "#616161",
              transition: "background-color 150ms, color 150ms",
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default ViewSelector;
